import { useEffect, useEffectEvent } from 'react'

/** Runs `fn` once, after mount — the `fn` of that moment, so it needs no dependency list. */
export const useMount = (fn: () => void) => {
  const onMount = useEffectEvent(fn)
  useEffect(() => {
    onMount()
  }, [])
}

/** Runs the latest `fn` once, on unmount. */
export const useUnmount = (fn: () => void): void => {
  const onUnmount = useEffectEvent(fn)
  useEffect(
    () => () => {
      onUnmount()
    },
    [],
  )
}
